import React from 'react';
import NavActivites from '../navactivities/navactivities';
import Header from '../../../header/header';
import Footer from '../../../footer/footer';

const CardioBoxing = (props) => {

  return (
    <div>
      <Header />
    <div id="stage">
    <div className="container">
        <div className="section-title">
        <NavActivites />

          <h2>Cardio boxing</h2>
          <br></br>
          <p>Le cardio boxing est une forme d'entraînement qui combine des techniques de boxe avec des exercices cardiovasculaires.</p>
        </div>
   <video controls className='img-responsive' src="../img/activites/cardioboxing/37eab2dd-49d0-4fd4-a6db-6b3251fab99e.MOV" />
<br></br>
<div className="stage-text">
<p><br></br> C’est une activité dynamique et énergique, souvent pratiquée en groupe, qui vise à améliorer la condition physique générale, la force, l'endurance et la coordination.</p>
  <br></br>
  <h4>Les caractéristiques principales du cardio boxing sont :</h4>
<ul>
<p><li>Mouvements de boxe : Les participants exécutent des coups de poing, des esquives et des déplacements, souvent en rythme avec de la musique.</li></p>
<p><li>Entraînement complet : Il sollicite de nombreux groupes musculaires, ce qui permet de travailler à la fois le haut et le bas du corps.</li></p>
<p><li>Amélioration du cardio : C'est un excellent exercice pour augmenter l'endurance cardiovasculaire.</li></p>
<p><li>Calorie brûlée : Les séances peuvent être très intenses, permettant de brûler un nombre significatif de calories.</li></p>
<p><li>Évacuation du stress : Les mouvements de boxe sont aussi un bon moyen d’évacuer le stress et de se défouler.</li></p>

</ul>
<br></br>
<p>Le cardio boxing est accessible à tous les niveaux de forme physique et peut être adapté en fonction des capacités individuelles.</p>
</div>
</div>
      </div>
      < Footer />
    </div>

  );
};
export default CardioBoxing;